import type { RatingSource } from "@finn-no/mobility-dealer-types";
import { WIcon } from "@mobility-item-page/client";
import { formatNumber } from "@mobility-item-page/utilities";
import { useOrganisationData } from "../context/OrganisationContext.tsx";

export const DealerRatings = ({ trackClick, className }: { trackClick: (url: string) => void; className?: string }) => {
  const {
    organisationData: { dealerRating },
    external: { locale },
  } = useOrganisationData();

  if (!dealerRating) {
    return null;
  }

  const resolvedDealerRatings = Object.values(dealerRating).filter((source): source is RatingSource => source != null);

  if (resolvedDealerRatings.length === 0) {
    return null;
  }

  return (
    <div className={className ? className : ""}>
      {resolvedDealerRatings.map((rating) => (
        <div key={rating.ratingLink.url} className="flex items-center space-x-4">
          <span className="font-bold">{formatNumber(rating.rating, locale, { minimumFractionDigits: 1 })}</span>
          <StarRating rating={rating.rating ?? 0} />
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={rating.ratingLink.url}
            onClick={() => trackClick(rating.ratingLink.url)}
          >
            {rating.ratingLink.text}
          </a>
        </div>
      ))}
    </div>
  );
};

const StarRating = ({ rating }: { rating: number }) => {
  return (
    <div className="flex items-center">
      {Array.from({ length: 5 }, (_, index) => {
        const starValue = index + 1;
        if (rating >= starValue - 0.2) {
          return <WIcon name="StarFull" key={starValue} className="s-icon-warning s-icon" />;
        } else if (rating >= starValue - 0.7) {
          return <WIcon name="StarHalf" key={starValue} className="s-icon-warning s-icon" />;
        } else {
          return <WIcon name="StarEmpty" key={starValue} className="s-icon-warning s-icon" />;
        }
      })}
    </div>
  );
};
